import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// An outdoor high-voltage circuit breaker: a steel mechanism tank on legs with
// two tall porcelain interrupter columns, each capped by a connector terminal.
// The switch that breaks fault currents in a substation.
const STEEL = "#878e96";
const LEG = "#6c727a";
const PORC = "#cfd2d4";
const SHED = "#b9bdc0";
const TERM = "#b87333";

function interrupter(x: number): Part[] {
  const out: Part[] = [
    { geometry: new THREE.CylinderGeometry(0.05, 0.055, 0.7, 12), color: PORC, position: [x, 0.75, 0] },
  ];
  // Sheds (the ribbed skirts) up the column.
  for (let i = 0; i < 5; i++) {
    out.push({ geometry: new THREE.CylinderGeometry(0.075, 0.075, 0.025, 12), color: SHED, position: [x, 0.5 + i * 0.12, 0] });
  }
  // Terminal connector on top.
  out.push({ geometry: new THREE.BoxGeometry(0.1, 0.06, 0.1), color: TERM, position: [x, 1.13, 0] });
  return out;
}

export const circuitBreaker = defineModel({
  id: "circuit-breaker",
  batchId: "electric",
  name: "Circuit breaker",
  tags: ["prop", "electric", "power", "grid", "substation", "breaker", "high-voltage"],
  summary: "An outdoor HV breaker: a tank on legs with two porcelain columns.",
  footprint: 0.4,
  parts(): Part[] {
    return [
      // Four legs.
      { geometry: new THREE.BoxGeometry(0.05, 0.4, 0.05), color: LEG, position: [-0.2, 0.2, -0.1] },
      { geometry: new THREE.BoxGeometry(0.05, 0.4, 0.05), color: LEG, position: [0.2, 0.2, -0.1] },
      { geometry: new THREE.BoxGeometry(0.05, 0.4, 0.05), color: LEG, position: [-0.2, 0.2, 0.1] },
      { geometry: new THREE.BoxGeometry(0.05, 0.4, 0.05), color: LEG, position: [0.2, 0.2, 0.1] },
      // Mechanism tank.
      { geometry: new THREE.BoxGeometry(0.56, 0.22, 0.28), color: STEEL, position: [0, 0.5, 0] },
      { geometry: new THREE.BoxGeometry(0.16, 0.18, 0.18), color: LEG, position: [0.22, 0.42, 0.16] },
      // Two interrupter columns.
      ...interrupter(-0.18),
      ...interrupter(0.18),
      // Cross connection bar.
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.36, 8), color: TERM, position: [0, 1.16, 0], rotation: [0, 0, Math.PI / 2] },
    ];
  },
  animations: [],
});
